export default __webpack_public_path__ + "static/media/cryptocurrency.83cc869c.svg";